import { GetSubscribeTicketsReqSchema } from '@server/schemas'

export type SubscribesTicketPaymentType = 'EXTEND' | 'SUBSCRIBE' | 'LUMP_SUM' | 'PAYBACK' | 'IPAD' | 'BUSINESS'

export const SUBSCRIBE_TICKETS_TAB: Record<Uppercase<SubscribesTicketPaymentType>, SubscribesTicketPaymentType> = {
  /** @description Extension subscription product */
  EXTEND: 'EXTEND',
  /** @description Regular subscription product */
  SUBSCRIBE: 'SUBSCRIBE',
  /** @description Lump-sum payment product */
  LUMP_SUM: 'LUMP_SUM',
  /** @description Payback product */
  PAYBACK: 'PAYBACK',
  /** @description Business English product */
  BUSINESS: 'BUSINESS',
  /** @description iPad package product */
  IPAD: 'IPAD',
} as const

export type SubscribesTicketPackagesTab = SubscribesTicketPaymentType

export type SubscribesTicketLanguageType = GetSubscribeTicketsReqSchema['langType']
export type SubscribesTicketTime = GetSubscribeTicketsReqSchema['lessonTime']
export type SubscribesTicketCount = Exclude<GetSubscribeTicketsReqSchema['lessonCountPerMonth'], undefined>

export const SUBSCRIBE_TICKET_COUNT_MAP = {
  UNLIMITED: 999,
  PER_MONTH_12: 12,
  PER_MONTH_8: 8,
} as const

export const SUBSCRIBE_TICKET_COUNT_OPTIONS = ['8', '12', '999'] satisfies SubscribesTicketCount[]
export const SUBSCRIBE_TICKET_TIME_OPTIONS = ['15', '25'] satisfies SubscribesTicketTime[]
export const SUBSCRIBE_TICKET_LANGUAGE_TYPE_OPTIONS = ['EN', 'JP', 'ENJP'] satisfies SubscribesTicketLanguageType[]
